import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import AppsIcon from '@mui/icons-material/Apps';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import SignLanguageIcon from '@mui/icons-material/SignLanguage';
import PostAddIcon from '@mui/icons-material/PostAdd';
import VideocamIcon from '@mui/icons-material/Videocam';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import Paper from '@mui/material/Paper';
import { useTranslation } from "react-i18next";


function ExpandableTableRow(props) {
    const { id, name, score, details, onlyOne } = props;
    const [ rowOpen, setRowOpen ] = useState(false);
    const ARR_ORDER_PARAMETERS_EXPANDABLE_ROW = ['VIDEO_POINTS','LEXICO_POINTS','VIDEO_QUANTITY','VIDEO_GREEN','VIDEO_YELLOW','VIDEO_RED','VIDEO_REVISED','NEW_VARIANT','NEW_SIGN','NEW_DEFINITION']

    useEffect(() => {
        if (onlyOne === undefined) {
            setRowOpen(false)
        }else{
            setRowOpen(true)
        }
    }, [onlyOne]);

    return (
        <>
        <TableRow className={`sig_ETR_Main ${rowOpen ? 'sig_ETR_MainOpened' : ''}`} onClick={() => setRowOpen((value) => !value)}>
            {onlyOne === undefined &&
                <>
                <TableCell className="table-cell" align="center"> {id} </TableCell>
                <TableCell className="table-cell" align="center"> {name} </TableCell>
                </>
            }
            <TableCell className="table-cell" align="center"> {score} </TableCell>
        </TableRow>
        <TableRow className='sig_ETR_Extra'>
            <TableCell className={`sig_ETR_ExtraCell ${rowOpen ? 'sig_ETR_ExtraCellOpen' : ''}`} colSpan={3}>
                <Collapse in={rowOpen} timeout={'auto'}>
                    <Table className='sig_ETR_ExtraContent'>
                        {ARR_ORDER_PARAMETERS_EXPANDABLE_ROW.map(( item, index ) => {

                            const data = details.filter(elem => elem[0] === item);
                            if (data.length > 0) {

                                let DetailIcon = VideocamIcon;
                                let detailIconColor = "#5ea0d4";
                                let detailLabel = "_";
                                switch (item) {
                                    case "VIDEO_POINTS":
                                        detailLabel = "Puntos de vídeos:";
                                        break;
                                    case "LEXICO_POINTS":
                                        detailLabel = "Puntos de léxico:";
                                        DetailIcon = MenuBookIcon;
                                        break;
                                    case "VIDEO_QUANTITY":
                                        detailLabel = "Número de vídeos:";
                                        DetailIcon = AppsIcon;
                                        break;
                                    case "VIDEO_GREEN":
                                        detailLabel = "Reconocimiento completo:";
                                        DetailIcon = SignLanguageIcon;
                                        detailIconColor = "#16ad44";
                                        break;
                                    case "VIDEO_YELLOW":
                                        detailLabel = "Reconocimiento parcial:";
                                        DetailIcon = SignLanguageIcon;
                                        detailIconColor = "#f7a716";
                                        break;
                                    case "VIDEO_RED":
                                        detailLabel = "Sin reconocimiento :";
                                        DetailIcon = SignLanguageIcon;
                                        detailIconColor = "#ff6363";
                                        break;
                                    case "VIDEO_REVISED":
                                        detailLabel = "Vídeos revisados:";
                                        DetailIcon = TaskAltOutlinedIcon;
                                        break;
                                    case "NEW_VARIANT":
                                        detailLabel = "Variantes de signos:";
                                        DetailIcon = AltRouteIcon;
                                        break;
                                    case "NEW_SIGN":
                                        detailLabel = "Nuevos signos:";
                                        DetailIcon = AddToQueueIcon;
                                        break;
                                    case "NEW_DEFINITION":
                                        detailLabel = "Nuevas definiciones:";
                                        DetailIcon = PostAddIcon;
                                        break;
                                
                                    default:
                                        console.error("Unexpected value for Team Ranking Details Label in ExpandableTableRow: ", item[0]);
                                        break;
                                }
                            

                                return (
                                    <TableRow key={index} className='sig_ETR_ExtraContent_Row'>
                                      <TableCell className="sig_ETR_DetailsLabel"> <div className='sig_ETR_DetailsLabel_Inner'><DetailIcon style={{ color: detailIconColor }} /> <span>{detailLabel}</span></div></TableCell>
                                      <TableCell className="sig_ETR_DetailsNumber"> {data[0][1]} </TableCell>
                                    </TableRow>
                                  );
                                }
                              })}
                    </Table>
                </Collapse>
            </TableCell>
        </TableRow>
        </>
    ); 
}

export function TeamRankingTable(props) {    
    const { rankingData, rankingType, onlyOne } = props;
    const { t } = useTranslation("global")

    // const rankingArray = Object.entries(rankingData).sort(sortHightoLow);
    const [ rankingArray, setRankingArray ] = useState([]);
    const [ rankingDetails, setRankingDetails ] = useState([]);

    function sortHightoLow(a, b) {
        return b[1][rankingType] - a[1][rankingType];
    }

    useEffect(()=>{
        // console.log("🚀 ~ file: TeamRankingTable.js:129 ~ TeamRankingTable ~ rankingData:", rankingData)
        // console.log("🚀 ~ file: TeamRankingTable.js:129 ~ TeamRankingTable ~ rankingType:", rankingType)
        setRankingArray(Object.entries(rankingData).sort(sortHightoLow))
    }, [rankingData, rankingType]);
    

    return (
        <div className="sig_VersusMachine_TopTableContainer">
            <TableContainer className="sig_VersusMachine_TopRankingContainer sig_TR_TopRankingContainer" components={{Container: props => <Paper {...props} elevation={0}/>}}>
                <Table className="custom-table sig_TR_TopRankingTable" aria-label="customized table">
                    <TableHead >
                        <TableRow>
                            {onlyOne === undefined &&
                                <>
                                <TableCell className="table-header sig_TR_TableHeader" align="center"> ID </TableCell>
                                <TableCell className="table-header sig_TR_TableHeader" align="center"> {t("sRanking.user")} </TableCell>
                                </>
                            }
                            <TableCell className="table-header sig_TR_TableHeader" align="center"> {t("sRanking.score")} </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rankingArray.map((data, index) => {
                            
                            const idx = data[0]
                            const namex = data[1]['NAME']
                            const scorex = data[1][rankingType]

                            if (index < 10 && scorex > 0) {
                                let tempDetails = [[]]; // TEMP, MIGHT USE OBJECT LATER
                                switch (rankingType) {
                                    case "TOTAL_POINTS":
                                        tempDetails = [
                                            ["VIDEO_POINTS", data[1]["VIDEO_POINTS"]],
                                            ["LEXICO_POINTS", data[1]["LEXICO_POINTS"]]
                                        ];
                                        break;
                                    case "VIDEO_POINTS":
                                        tempDetails = Object.entries(data[1]["VIDEO_DETAILS"]);
                                        break;
                                    case "LEXICO_POINTS":
                                        tempDetails = Object.entries(data[1]["LEXICO_DETAILS"]);
                                        break;
                                    default:
                                        console.error(
                                            "Unexpected value for Team Ranking Type Label in Team Ranking Table: ",
                                            rankingType
                                        );
                                        break;
                                }

                                return (
                                    <ExpandableTableRow
                                        key={index}
                                        id={idx}
                                        name={namex}
                                        score={scorex}
                                        details={tempDetails}
                                        onlyOne={onlyOne}
                                    />
                                );
                            } else {
                                return <></>;
                            }
                        })}
                    </TableBody>
                </Table>  
            </TableContainer>
        </div>
    );
}